  export enum CountriesActionTypes {
    GET_COUNTRIES = 'GET_COUNTRIES',
    GET_COUNTRY_CODE = 'GET_COUNTRY_CODE',
    GET_COMPANY_INFO = 'GET_COMPANY_INFO'
  }
  